// extracted by mini-css-extract-plugin
module.exports = {"logo-root":"Logo_logo-root__2HCyk"};